export const LOGO_URL =
    "https://customer-assets-4nw71qhi.emergentagent.net/job_portal-spaces/artifacts/v6lkxr50_ChatGPT%20Image%20Sep%2024%2C%202026%2C%2007_58_59%20PM.png";

export const LOGO_PNG = "/brand/logo.png";

import PROJECT_PREVIEWS from "./projectPreviews.json";

export const STAGES = [
    {
        id: "interior",
        index: "01",
        name: "INTERIOR",
        line: "STEP INSIDE.",
        sub: "Interior · 360° Walkthrough",
        img: "/img/hero-interior.jpg",
    },
    {
        id: "exterior",
        index: "02",
        name: "EXTERIOR",
        line: "SEE THE WHOLE SPACE.",
        sub: "Exterior · 360° Walkthrough",
        img: "https://images.unsplash.com/photo-1758192838598-a1de4da5dcaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtYW5zaW9uJTIwZXh0ZXJpb3IlMjBwb29sJTIwcGFsbSUyMHRyZWVzJTIwc3Vuc2V0fGVufDB8fHx8MTc5MDM3ODg3OXww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "aerial",
        index: "03",
        name: "AERIAL",
        line: "CHANGE YOUR PERSPECTIVE.",
        sub: "Aerial & Drone Cinematography",
        video_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_portal-spaces/artifacts/h167t9m7_FPV%20Video%201.mp4",
        img: "https://images.unsplash.com/photo-1506252374453-ef5237291d83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6NzF8MHwxfHNlYXJjaHw0fHxjYWxpZm9ybmlhJTIwY29hc3QlMjBvY2VhbiUyMGRyb25lJTIwYWVyaWFsJTIwdHVycXVvaXNlJTIwd2F2ZXN8ZW58MHx8fHwxNzkwMzc4ODk5fDA&ixlib=rb-4.1.0&q=85",
    },
];

export const SERVICES = [
    {
        number: "01",
        tag: "Core service",
        cursor: "camera",
        title: "Immersive 360° Walkthroughs",
        subtitle: "Interior & exterior · one continuous experience",
        description:
            "Interactive 360° experiences that let people move through a property — inside and out — and understand its layout, scale, light and atmosphere before they arrive. Hotspots add information, media and direct actions; the experience lives on your website, a link or a QR code.",
        details: [
            "Interior & exterior spaces, one walkthrough",
            "Interactive hotspots, information & media layers",
            "Website embedding, direct links & QR access",
            "Google integration where applicable",
        ],
        image_url: "/img/service-360.jpg",
    },
    {
        number: "02",
        tag: "Cinematic production",
        cursor: "drone",
        video_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_portal-spaces/artifacts/tywo1n6c_FPV%20Video%202.mp4",
        title: "Aerial & Drone Cinematography",
        subtitle: "Perspective impossible from the ground",
        description:
            "Cinematic drone filming and fly-throughs that place a property in its setting — establishing shots, dynamic movement around architecture, and single-take flights that carry the viewer from the sky to the threshold.",
        details: [
            "Cinematic aerial filming",
            "Drone fly-throughs",
            "Establishing shots & property context",
            "Dynamic movement around architecture",
        ],
        image_url:
            "https://images.unsplash.com/photo-1597982087634-9884f03198ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1ODh8MHwxfHNlYXJjaHwxfHxsb3MlMjBhbmdlbGVzJTIwYWVyaWFsJTIwdmlld3xlbnwwfHx8fDE3OTAzNzg5MDN8MA&ixlib=rb-4.1.0&q=85",
    },
];

export const OMNIA_PROJECT = {
    title: PROJECT_PREVIEWS.omnia.title,
    category: "IMMERSIVE 360° · ENCINO, CALIFORNIA",
    image: PROJECT_PREVIEWS.omnia.image,
    description: PROJECT_PREVIEWS.omnia.description,
    websiteUrl: "https://omniawellnesscenterencino.com",
    tourUrl: "https://kuula.co/share/collection/7d5TR?logo=1&info=0&fs=1&vr=1&autorotate=0.02&thumbs=1",
};

export const PROJECTS = [
    {
        id: "project-1",
        title: PROJECT_PREVIEWS["baldwin-hills"].title,
        category: "IMMERSIVE 360° · BALDWIN HILLS, CALIFORNIA",
        location: "Baldwin Hills, California",
        year: "2026",
        scope: PROJECT_PREVIEWS["baldwin-hills"].description,
        image: PROJECT_PREVIEWS["baldwin-hills"].image,
        tourUrl: "https://kuula.co/share/L6FZd/collection/7dp7V?logo=1&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.02&thumbs=-1",
    },
    {
        id: "khinkali-house",
        title: "KHINKALI HOUSE BEVERLY HILLS",
        category: "IMMERSIVE 360° · BEVERLY HILLS, CALIFORNIA",
        scope: PROJECT_PREVIEWS["khinkali-house"].description,
        image: PROJECT_PREVIEWS["khinkali-house"].image,
        tourUrl: "/khinkali-house",
        websiteUrl: "https://www.khinkalihouse.com/beverly-hills/",
    },
    {
        id: "lucky-penny",
        title: PROJECT_PREVIEWS["lucky-penny"].title,
        category: "IMMERSIVE 360° · LONG BEACH, CALIFORNIA",
        scope: PROJECT_PREVIEWS["lucky-penny"].description,
        image: PROJECT_PREVIEWS["lucky-penny"].image,
        tourUrl: "/lucky-penny",
        instagramUrl: "https://www.instagram.com/luckypennylongbeach",
    },
    {
        id: "dungeon",
        title: PROJECT_PREVIEWS.dungeon.title,
        category: "IMMERSIVE 360°",
        scope: PROJECT_PREVIEWS.dungeon.description,
        image: PROJECT_PREVIEWS.dungeon.image,
        tourUrl: "/dungeon",
    },
    {
        id: "project-2",
        title: "Malibu Bluff Retreat",
        category: "Hospitality · Aerial & Drone",
        location: "Malibu Coast, CA",
        year: "2026",
        scope: "Cinematic aerial film + exterior walkthrough",
        image: STAGES[2].img,
    },
    {
        id: "project-3",
        title: "Trousdale Sanctuary",
        category: "Wellness · 360° Walkthrough",
        location: "Beverly Hills, CA",
        year: "2025",
        scope: "Interactive 360° experience with hotspots",
        image: STAGES[1].img,
    },
];

export const MOSAIC_PROJECT = {
    title: PROJECT_PREVIEWS["mosaic-mansion"].title,
    category: "IMMERSIVE 360° · HOLLYWOOD HILLS, CALIFORNIA",
    description: PROJECT_PREVIEWS["mosaic-mansion"].description,
    image: PROJECT_PREVIEWS["mosaic-mansion"].image,
    video: "https://customer-assets-4nw71qhi.emergentagent.net/job_portal-spaces/artifacts/2e65452660a3fad7_drone%201.mp4",
    instagramUrl: "https://www.instagram.com/themosaicmansion/",
    tourUrl: "https://kuula.co/share/collection/7dGM6?logo=1&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.02&thumbs=-1",
};

export const TOUR_REDIRECTS = Object.fromEntries(
    Object.entries(PROJECT_PREVIEWS).map(([slug, project]) => [`/${slug}`, project.redirectUrl])
);

export const STEPS = [
    {
        index: "01",
        word: "Move",
        image: "/img/step-move.jpg",
        text: "Walk through the space naturally — room to room, inside to outside — at your own pace.",
    },
    {
        index: "02",
        word: "Look",
        image: "/img/step-look.jpg",
        text: "Explore every angle in 360°. Understand the space rather than glance at a photograph of it.",
    },
    {
        index: "03",
        word: "Discover",
        image: "/img/step-discover.jpg",
        text: "Interactive hotspots reveal information, details, menus, services, images and media — inside the environment.",
    },
    {
        index: "04",
        word: "Act",
        image: "/img/step-act.jpg",
        text: "Book, reserve, contact, visit a website or learn more — directly from the experience.",
    },
];

export const TOUR = {
    embedUrl:
        "https://kuula.co/share/L6FZd/collection/7dp7V?logo=-1&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.02&thumbs=-1",
    title: "Open-Plan Living",
    location: "Live walkthrough · Interior & exterior captured as one experience",
    hotspots: [
        {
            id: "living",
            index: "01",
            title: "Living Area",
            description:
                "A calm, inviting lounge anchored by soft textures, warm wood flooring, and a clean open layout designed for effortless everyday living.",
            cta: "View Living Space",
        },
        {
            id: "kitchen",
            index: "02",
            title: "Kitchen Island",
            description:
                "A sculptural stone island creates a natural focal point for gathering, serving, and casual dining, combining function with a refined material palette.",
            cta: "Explore Kitchen Details",
        },
        {
            id: "dining",
            index: "03",
            title: "Dining Area",
            description:
                "Positioned beside generous glazing, the dining area feels bright, open, and connected, ideal for both daily meals and relaxed entertaining.",
            cta: "View Dining Space",
        },
        {
            id: "flow",
            index: "04",
            title: "Open-Plan Flow",
            description:
                "The living, dining, and kitchen zones are visually connected in one continuous experience, helping the space feel larger, brighter, and more social.",
            cta: "See Spatial Flow",
        },
        {
            id: "start",
            index: "05",
            title: "Interested in an experience like this?",
            description:
                "Interactive walkthroughs help visitors understand a property before they arrive and take action directly from the experience.",
            cta: "Start a Project",
            action: "contact",
        },
    ],
};

export const PERSPECTIVES = [
    { word: "Inside", label: "360° walkthrough" },
    { word: "Outside", label: "360° walkthrough & context" },
    { word: "Above", label: "Aerial & drone cinematography" },
];

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) {
        if (window.location.pathname !== "/") window.location.assign(`/#${encodeURIComponent(id)}`);
        return;
    }
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { duration: 1.6 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
